import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function Footer() {
  const { t } = useLang();

  const nav = [
    { to: "/", label: t.nav.home },
    { to: "/about", label: t.nav.about },
    { to: "/solutions", label: t.nav.solutions },
    { to: "/case-studies", label: t.nav.cases },
    { to: "/insights", label: t.nav.insights },
    { to: "/ecosystem", label: t.nav.portal },
    { to: "/contact", label: t.nav.contact },
  ];

  return (
    <footer data-testid="footer" className="relative border-t border-white/10 bg-navy">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <div className="flex items-center gap-3">
              <svg width="24" height="24" viewBox="0 0 32 32" fill="none">
                <rect x="1" y="1" width="30" height="30" stroke="#00E5FF" strokeWidth="1.5" />
                <path d="M9 9v14h11" stroke="#00E5FF" strokeWidth="2" />
                <circle cx="22" cy="10" r="2.5" fill="#00E5FF" />
              </svg>
              <span className="font-display font-semibold text-lg tracking-tight">Litterantara</span>
            </div>
            <p className="mt-5 text-[#94A3B8] leading-relaxed max-w-sm text-sm">{t.footer.blurb}</p>
            <p className="mt-6 font-mono-tech text-[11px] uppercase tracking-widest text-cyan-precision">
              {t.brand.tagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-mono-tech text-[11px] uppercase tracking-widest text-[#94A3B8] mb-5">
              {t.footer.nav}
            </h4>
            <ul className="space-y-3">
              {nav.map((n) => (
                <li key={n.to}>
                  <Link
                    to={n.to}
                    data-testid={`footer-nav-${n.to === "/" ? "home" : n.to.slice(1)}`}
                    className="text-[#F0F4F8]/80 hover:text-cyan-precision transition-colors text-sm"
                  >
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-mono-tech text-[11px] uppercase tracking-widest text-[#94A3B8] mb-5">
              {t.footer.contactTitle}
            </h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-center gap-3 text-[#F0F4F8]/80">
                <Mail size={16} className="text-cyan-precision" /> {t.contact.email}
              </li>
              <li className="flex items-center gap-3 text-[#F0F4F8]/80">
                <Phone size={16} className="text-cyan-precision" /> {t.contact.phone}
              </li>
              <li className="flex items-center gap-3 text-[#F0F4F8]/80">
                <MapPin size={16} className="text-cyan-precision" /> {t.contact.address}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3">
          <p className="font-mono-tech text-[11px] uppercase tracking-widest text-[#94A3B8]">
            © {new Date().getFullYear()} Litterantara. {t.footer.rights}
          </p>
          <p className="font-mono-tech text-[11px] uppercase tracking-widest text-[#94A3B8]/60">
            {t.footer.built}
          </p>
        </div>
      </div>
    </footer>
  );
}
